import { Builder } from '@builder.io/react';
import Speakers from './Speakers';

Builder.registerComponent(Speakers, {
  name: 'Speakers',
  inputs: [
    {
      name: 'location',
      type: 'string',
      enum: [
        'Show All',
        'London',
        'San Francisco',
      ],
      defaultValue: 'Show All',
      helperText: 'Select Show All to display all speakers, regardless of their location choice.'
    },
    {
      name: 'avatarPlaceholder',
      type: 'file',
      allowedFileTypes: ['svg', 'png', 'jpg'],
      helperText: 'Placeholder image to be used when speaker avatar is not available.',
    },
    {
      name: 'londonChipColor',
      type: 'color',
    },
    {
      name: 'sfChipColor',
      type: 'color',
    },
  ],
});

